import React from 'react';
import {GoogleLogout} from 'react-google-login';
import {If} from 'react-if';

import {clientId} from './config/googleClientId';

export default function Logout({isLoggedIn, onLogoutSuccess, onFailure}:any) {
    return (
        <If condition={isLoggedIn}>
            <GoogleLogout
                clientId={clientId}
                buttonText="Logout"
                onLogoutSuccess={onLogoutSuccess}
                onFailure={onFailure}
            />
        </If>
    );
}
